import styled, { keyframes } from "styled-components";

const BLOCK_HEIGHT = 40;

const gradientShimmer = keyframes`
    0% {
        background-position: -1000px 0;
    }

    100% {
        background-position: 1000px 0;
    }
`;

const ShimmerDiv = styled.div`
    background: linear-gradient(
        90deg,
        ${(props) => props.theme.colors[props.theme.colorMode].background_Tertiary} 0%,
        ${(props) => props.theme.colors[props.theme.colorMode].background_Secondary} 52.08%,
        ${(props) => props.theme.colors[props.theme.colorMode].background_Tertiary} 100%
    );
    background-size: 1000px 100%;
    animation: ${gradientShimmer} 3s infinite linear;
`;

export const FixedBottomBlock = styled.div`
    bottom: 0;
    width: 100%;
    background: ${(props) => props.theme.colors[props.theme.colorMode].background_Primary};
`;

export const BlockContent = styled.div`
    background: ${(props) => props.theme.colors[props.theme.colorMode].background_Primary};
    padding: ${(props) => `${props.theme.spacing.medium} ${props.theme.spacing.medium} 0`};
    min-height: ${BLOCK_HEIGHT}px;
`;

export const Line = styled(ShimmerDiv)<{ width?: number; height?: number }>`
    height: ${(props) => props.height || 12}px;
    width: ${(props) => props.width || 100}%;
`;

export const PayButton = styled(Line)`
    border-radius: ${(props) => props.theme.cornerRadius.medium};
`;

export const PaymentMethodLine = styled(Line)`
    margin-bottom: ${(props) => props.theme.spacing.medium};
    border-radius: ${(props) => props.theme.cornerRadius.xxSmall};
`;

export const PaymentMethodIcon = styled(PaymentMethodLine)`
    margin-right: ${(props) => props.theme.spacing.xxSmall};
`;

export const Row = styled.div`
    display: flex;
    align-items: center;
    flex: 1;
`;

export const Col = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
`;
